var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(item,index){return _c('span',{key:index,class:[{ 'tabs_active': _vm.selectedTab.prop === item.prop }],on:{"click":function($event){return _vm.tabClick(item)}}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }